/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kuendigungart1Inputs */

const de__field_kuendigungart1 = /** @type {(inputs: _Field_Kuendigungart1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art der Kündigung`)
};

/**

* @param {_Field_Kuendigungart1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kuendigungart1 = /** @type {((inputs?: _Field_Kuendigungart1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kuendigungart1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kuendigungart1(inputs)
});
export { _field_kuendigungart1 as "_field_kuendigungArt" }